import React, {useState, useEffect, useRef} from "react";
import styled from "styled-components";
import Calendar, {getDayList, getWeekList, getWeekNameList} from "components/ui/Calendar";
import Slider from "components/ui/Slider";
import {getCalendar, getDateAdd} from "utils/date";
import backIcon from "assets/icons/icon_back_black.svg";

export const Month = (props) => {
	const parentRef = useRef();
	const childRef = useRef();

	const today = getCalendar();
	const [date, setDate] = useState((props.date) ? props.date : getCalendar(null, "yyyy-mm-01"));
	const [value, setValue] = useState(props.value);
	const [index, setIndex] = useState(1);

	useEffect(() => {
		eventHandler.update();
	}, []);

	const eventHandler = {
		prev : () => {
			childRef.current.prev();
		},
		next : () => {
			childRef.current.next();
		},
		update : (eventInfo) => {
			if(eventInfo) {
				setDate(date => {
					return getDateAdd(date, 0, 1 * eventInfo.direction);
				});
			}
			if(props.onUpdate) {
				props.onUpdate(value);
			}
		},
		change : (value) => {
			setValue(value);
			if(props.onChange)
				props.onChange(value);
		}
	};

	const render = () => {
		const getHead = () => {
			const weekList = getWeekNameList();
			const li = weekList.map((item, index) => {
				return (<li key={index}>{item}</li>);
			});
			return (<ul className="middle-top">{li}</ul>);
		};

		const getBody = (index) => {
			const getDate = () => {
				const dateList = [getDateAdd(date, 0, -1), date, getDateAdd(date, 0, 1)];
				if(parentRef.current) {
					const li = parentRef.current.querySelectorAll("li[data-index]");
					for(let i = 0; i < 3; i++) {
						if(Number(li[i].getAttribute("data-index")) == index) {
							return dateList[i];
						}
					}
				} else {
					return dateList[index];
				}
			};
			return (
				<Calendar
					mode={props.mode}
					date={getDate()}
					value={value}
					import={true}
					onChange={eventHandler.change}
					onRender={props.onRender}
				/>
			);
		};

		const title = getCalendar(date, "yyyy년 sm월");

		return (
			<Wrapper ref={parentRef} className={(props.import) ? "import" : ""}>
				<div className="top">
					<button className="prev" type="button" onClick={eventHandler.prev}></button>
					<h2>{title}</h2>
					<button className="next" type="button" onClick={eventHandler.next}></button>
				</div>
				<div className="middle">
					{getHead()}
					<Slider ref={childRef} index={index} isLoop={true} onChange={eventHandler.update}>
						<ul>
							<li data-index="0">{getBody(0)}</li>
							<li data-index="1">{getBody(1)}</li>
							<li data-index="2">{getBody(2)}</li>
						</ul>
					</Slider>
				</div>
			</Wrapper>
		);
	};

	return render();
};

const Wrapper = styled.div`
	&								{padding:10px 12px 8px 12px; background-color:white; border-radius:var(--borderRadius); border:1px solid var(--border)}
	&.import						{padding:0; border-radius:0; border:none}
	
	.top							{display:flex; margin:3px 0; align-items:center; justify-content:center; font-size:1.35rem}
	.top h2							{font-size:inherit}
	.top button						{display:inline-flex; margin:0 12px; width:1.25em; height:1.25em; background:white url(${backIcon}) no-repeat center center / 33%; border:none; opacity:0.85}
	.top button.next				{transform:rotate(180deg)}

	& > .middle						{margin:10px -4px 0 -4px}
	.middle li						{padding:0; background-color:white}
	
	.middle-top						{display:flex; padding:10px 0 5px 0; color:#949db2}
	.middle-top li					{display:flex; width:100%; justify-content:center}
	.middle-top li:first-child		{color:#fa7575}
	.middle-top li:last-child		{color:#6d88e9}
`;

export default Month;